import { render, staticRenderFns } from "./WorkClientContactModal.vue?vue&type=template&id=11d79800&"
import script from "./WorkClientContactModal.vue?vue&type=script&lang=js&"
export * from "./WorkClientContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports